import React from "react";
import ChrMetricContainer from "../../generic/PageUI/Basic/Metric/ChrMetricContainer";
import ChrMetricTitle from "../../generic/PageUI/Basic/Metric/ChrMetricTitle";
import ChrMetricValue from "../../generic/PageUI/Basic/Metric/ChrMetricValue";
import { metricType } from "../../generic/PageUI/constants";
import ChrAlert from "../../generic/PageUI/Basic/Metric/ChrAlert";

const OverviewSubMetric = (props) => {
  const { name, data: { value, formattedValue, alert = {} }, url, helpText, eventDetails } = props;

  return (
    <ChrMetricContainer className='mr-3 cui-min-width-50'>
      <div className=" d-flex flex-gap-5 align-items-center">
        <ChrMetricTitle type={ metricType.SUBMETRIC } helpText={ helpText }>
          { name }
        </ChrMetricTitle>
        <ChrMetricValue type={ metricType.SUBMETRIC } url={ url } eventDetails={ eventDetails } formattedValue={ formattedValue }>
          { value }
        </ChrMetricValue>
        <ChrAlert { ...alert } containerLocator="#cjs-management-report-v2" className="pr-2" additionalIconClass="fa-sm" />
      </div>
    </ChrMetricContainer>
  );
};

export default OverviewSubMetric;